// Kategória forrás-igazság: a modellnév → kategória leképezés ÉS a megjelenítendő
// kategória-lista (kulcs, címke, emoji) EGY helyen él, hogy a /telefonok szűrősáv
// és a főmenü legördülő ugyanazt használja. A darabszámok mindig a valódi
// készletből számolódnak (NEM hardcode) – lásd a `categoryCounts` memókat.

/** Gyártó a modellnévből (a Product schema `brand` mezőjéhez).
 *
 *  FIGYELEM: az office készlet-API NEM ad `brand` mezőt, ezért a márkát a
 *  modellnévből vezetjük le. Ismeretlen névnél `null` – ilyenkor a schema-ból
 *  a brand KIMARAD (nem találgatunk gyártót). Ha az API egyszer ad brand
 *  mezőt, ez a helper elhagyható és az adat közvetlenül használható.
 */
export const getBrand = (name = '') => {
  const n = String(name).toLowerCase();
  if (/iphone|ipad|airpods|apple|mac/.test(n)) return 'Apple';
  if (/samsung|galaxy/.test(n)) return 'Samsung';
  if (/xiaomi|redmi|poco/.test(n)) return 'Xiaomi';
  if (/huawei/.test(n)) return 'Huawei';
  if (/honor/.test(n)) return 'Honor';
  if (/oppo/.test(n)) return 'OPPO';
  if (/realme/.test(n)) return 'realme';
  if (/motorola|moto/.test(n)) return 'Motorola';
  if (/nokia/.test(n)) return 'Nokia';
  if (/google|pixel/.test(n)) return 'Google';
  if (/playstation|\bps[45]\b|sony/.test(n)) return 'Sony';
  if (/xbox|microsoft/.test(n)) return 'Microsoft';
  return null;
};

export const getCategory = (model = '') => {
  const m = model.toLowerCase();
  if (m.includes('iphone'))               return 'iPhone';
  if (m.includes('ipad'))                 return 'iPad';
  if (m.includes('watch') && (m.includes('samsung') || m.includes('galaxy'))) return 'Samsung Watch';
  if (m.includes('apple watch') || m.includes('watch')) return 'Apple Watch';
  if (m.includes('airpods') || m.includes('airpod'))   return 'AirPods';
  if (m.includes('airtag'))                            return 'AirTag';
  if (m.includes('apple pencil') || m.includes('pencil')) return 'Apple Pencil';
  if (m.includes('macbook'))                           return 'MacBook';
  if (m.includes('huawei'))                            return 'Huawei';
  if (m.includes('honor'))                             return 'Honor';
  if (m.includes('samsung'))              return 'Samsung';
  if (m.includes('xiaomi') || m.includes('redmi') || m.includes('poco')) return 'Xiaomi';
  if (m.includes('playstation') || m.includes('ps4') || m.includes('ps5') || m.includes('xbox')) return 'Konzol';
  return 'Egyéb';
};

// A megjelenítendő kategóriák sorrendje + címkéje + emoja. A „Mind” (üres kulcs)
// nincs benne – azt a szűrősáv külön kezeli. A darabszám mindig futásidőben jön.
export const PHONE_CATEGORIES = [
  { key: 'iPhone',        label: 'iPhone',        icon: '🍎' },
  { key: 'Samsung',       label: 'Samsung',       icon: '🔵' },
  { key: 'Samsung Watch', label: 'Samsung Watch', icon: '⌚' },
  { key: 'iPad',          label: 'iPad',          icon: '📱' },
  { key: 'MacBook',       label: 'MacBook',       icon: '💻' },
  { key: 'Apple Watch',   label: 'Apple Watch',   icon: '⌚' },
  { key: 'AirPods',       label: 'AirPods',       icon: '🎧' },
  { key: 'AirTag',        label: 'AirTag',        icon: '🏷️' },
  { key: 'Apple Pencil',  label: 'Apple Pencil',  icon: '✏️' },
  { key: 'Huawei',        label: 'Huawei',        icon: '🔴' },
  { key: 'Honor',         label: 'Honor',         icon: '💎' },
  { key: 'Xiaomi',        label: 'Xiaomi',        icon: '🔶' },
  { key: 'Konzol',        label: 'Konzol',        icon: '🎮' },
];

// A /telefonok?kategoria=<slug> URL-paraméter <-> belső kategória-kulcs leképezés.
// A slug ékezet/szóköz-mentes, kisbetűs (megosztható, szép URL).
export const CATEGORY_SLUGS = PHONE_CATEGORIES.reduce((acc, c) => {
  const slug = c.key.toLowerCase().replace(/\s+/g, '-');
  acc.slugToKey[slug] = c.key;
  acc.keyToSlug[c.key] = slug;
  return acc;
}, { slugToKey: {}, keyToSlug: {} });

export const categorySlug = (key) => CATEGORY_SLUGS.keyToSlug[key] || '';
export const categoryFromSlug = (slug) => CATEGORY_SLUGS.slugToKey[String(slug || '').toLowerCase()] || '';
